import { http } from "../client";
export var dislikeDeviceCurrentTrack = function (id) {
    return http.api.post("devices/" + id + "/dislike");
};
